import { useFirestore } from "@/hooks/firestore/core/useFirestore";

import { statisticsSchema } from "../models/statistics";

export const useEventStatistics = (eventId?: string, statisticId?: string) => {
  const key =
    eventId && statisticId
      ? `bettingEvents/${eventId}/statistics/${statisticId}`
      : null;

  const { data, error, isLoading } = useFirestore(key, statisticsSchema, {
    keyPath: `id`,
  });

  return {
    statistics: data,
    loading: isLoading,
    error,
  };
};
